export default __webpack_public_path__ + "54697dcefd8fc07eefdd7f3424ef4423.png";